export const PRODUCT_TO_DISPLAY_NAME = {
	confluence: 'Confluence',
	'jira-core': 'Jira Work Management',
	'jira-product-discovery': 'Jira Product Discovery',
	'jira-servicedesk': 'Jira Service Management',
	'jira-software': 'Jira Software',
	townsquare: 'Atlas',
	bitbucket: 'Bitbucket',
};

export type Product = keyof typeof PRODUCT_TO_DISPLAY_NAME;

export const getProductDisplayName = (product: Product): string => PRODUCT_TO_DISPLAY_NAME[product];
